module.exports = __webpack_public_path__ + "img/calendar-illustration.fcb4640f.png";